import { gql } from '@apollo/client';

export default gql`
    query sso_info {
        result: realmInfo {
            offlineSessionIdleTimeout
        }
    }
`;
